import VendorSearchResultsHtml from '../../app-lite/vendors/templates/vendors.search.results.html';

export function ProlinkSettingsCtrl (
  $state,
  $scope,
  $translate,
  confirm,
  messages,
  settings,
  streamSearch,
  Vendor,
  workshopAPI
) {
  $scope.loaded = true;
  $scope.settings = settings;

  $scope.activate = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', {name:"PROLink"}))
    .then(function () {
      return workshopAPI.get('/company/add_prolink');
    }).then(function () {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {name:"PROLink"}), 'success');
      $state.reload();
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.deactivate = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.DEACTIVATE', {name:"PROLink"}))
    .then(function () {
      return workshopAPI.get('/company/remove_prolink');
    }).then(function () {
      $state.reload();
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.save = function () {
    workshopAPI.patch('/company', $scope.settings, 'company')
    .then(function () {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');
      $state.reload();
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.vendorSearch = {
    list: [],
    selected: {
      id: $scope.settings.prolink_vendor_id,
      company_name: $scope.settings.prolink_settings.prolink_vendor_name,
    },
    search (typed) {
      const self = this;

      return streamSearch.search('vendors', typed).then(vendors => {
        return self.list.concat(vendors);
      });
    },
    new () {
      var self = this;

      Vendor.quickAdd().then(vendor => {
        self.selected = vendor;

        $scope.settings.prolink_vendor_id                    = vendor.id;
        $scope.settings.prolink_settings.prolink_vendor_name = vendor.company_name;

        messages.show($translate.instant('JS_SPACE.INTEGRATIONS.SUPPLIER_FOR_INTEGRATION', {name:"PROLink"}), 'success');
      });
    },
    choose (vendor) {
      $scope.settings.prolink_vendor_id                    = vendor.id;
      $scope.settings.prolink_settings.prolink_vendor_name = vendor.company_name;
    },
    format (vendor) {
      return vendor ? vendor.company_name: '';
    },
    templateUrl: VendorSearchResultsHtml
  };
}